import axios from "axios";
import aes from "crypto-js/aes";
import encHex from "crypto-js/enc-hex";
import padZeroPadding from "crypto-js/pad-zeropadding";
import CryptoJS from "crypto-js";
import { store } from '../store/store';

const key = encHex.parse(process.env.REACT_APP_ENC_KEY);
const iv = encHex.parse(process.env.REACT_APP_ENC_IV);

const encryptPayload = (data) => {
  const encryptedData = aes
    .encrypt(JSON.stringify(data), key, { iv: iv, padding: padZeroPadding })
    .toString();
  return encryptedData;
};

// Setup Axios Instance

export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


// Setup Axios Token Instance

export const TOKEN_API = axios.create({
  baseURL: process.env.REACT_APP_TOKEN_API_URL,
});

// Setup Services Axios Instance

export const SERVICES_API = axios.create({
  baseURL: process.env.REACT_APP_SERVICES_API_URL,
  transformRequest: [
    (data, headers) => {
      const encryptedPayload = encryptPayload(data);
      data = {
        data: encryptedPayload,
      };
      return JSON.stringify(data);
    },
  ],
  headers: {
    "Content-Type": "application/json",
  },
});


// Automagically put OAuth token on requests if it exists

SERVICES_API.interceptors.request.use(config => {
  const state = store.getState();
  const token = state.auth?.getAuth?.data?.access_token;
  if (token) {
      config.headers.Authorization =  `Bearer ${token}`;
  }
  return config;
});


SERVICES_API.interceptors.response.use(
  (response) => {    
    const decrypted = aes
      .decrypt(response.data, key, { iv: iv })
      .toString(CryptoJS.enc.Utf8);
    response.data = JSON.parse(decrypted);
    return response;
  },

  function (error) {
    if (error.response.data.result == false) {
      return Promise.reject(error);
    }
    let key = encHex.parse(process.env.REACT_APP_ENC_KEY);
    let iv = encHex.parse(process.env.REACT_APP_ENC_IV);

    const decrypted = aes
      .decrypt(error.response.data, key, { iv: iv })
      .toString(CryptoJS.enc.Utf8);
    error.response.data = JSON.parse(decrypted);
    return Promise.reject(error);
  }
);


// Setup OTP Axios Instance

export const OTP_API = axios.create({
  baseURL: process.env.REACT_APP_SERVICES_API_URL,
});